import type { DiseaseType, FindingType } from "../mappers";
import type { DiseaseRecommender } from ".";
import { type LookupRule, PREDEFINED_LOOKUP_RULES } from "./lookup-rules";

type LookupDictionary = {
  [key: string]: DiseaseType[];
};

const generateFindingsKey = (findings: FindingType[]): string =>
  findings.sort().join("-");

export class LookupFirstRecommender implements DiseaseRecommender {
  static fromMappings(
    innerRecommender: DiseaseRecommender,
    rules: LookupRule[] = PREDEFINED_LOOKUP_RULES,
  ): LookupFirstRecommender {
    return new LookupFirstRecommender(
      innerRecommender,
      convertToLookupDictionary(rules),
    );
  }
  constructor(
    private readonly innerRecommender: DiseaseRecommender,
    private readonly lookupDictionary: LookupDictionary,
  ) {}

  recommend(findings: FindingType[]): DiseaseType[] {
    const key = generateFindingsKey(findings);
    const dictionaryDiseases = this.lookupDictionary[key];
    if (dictionaryDiseases) {
      return dictionaryDiseases;
    }
    return this.innerRecommender.recommend(findings);
  }
}

const convertToLookupDictionary = (rules: LookupRule[]): LookupDictionary =>
  rules.reduce((acc, { inputFindings, recommendedDiseases }) => {
    acc[generateFindingsKey(inputFindings)] = recommendedDiseases;
    return acc;
  }, {} as LookupDictionary);
